// AJAX Cart Handler for Shopify Theme
// Prevents redirect to cart page and handles AJAX submissions

(function() {
  'use strict';

  // Function to handle AJAX cart submission
  function handleAjaxAddToCart(form) {
    const formData = new FormData(form);

    // Add the cart endpoint
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      // Success - item added to cart
      console.log('Product added to cart:', data);

      // Update button state to show success
      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) {
        submitButton.classList.add('is-added');

        // Reset button state after 2 seconds
        setTimeout(() => {
          submitButton.classList.remove('is-added');
        }, 2000);
      }

      // ALWAYS call monster_refresh() if it exists
      if (typeof monster_refresh === 'function') {
        console.log('Calling monster_refresh()');
        monster_refresh();
      }

      // Trigger cart drawer or update cart count (if your theme has this)
      if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
        window.CartDrawer.refresh();
      }

      // Dispatch custom event for other cart components
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { items: data }
      }));

      // Update cart count in header if element exists
      updateCartCount();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);

      // Show error message
      const errorContainer = form.querySelector('[data-cart-errors-container]');
      if (errorContainer) {
        errorContainer.innerHTML = `
          <div class="product-form__error-message">
            <span>There was an error adding this item to cart. Please try again.</span>
          </div>
        `;
      }
    });
  }

  // Function to update cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update all cart count elements
        document.querySelectorAll('[data-cart-count]').forEach(element => {
          element.textContent = cart.item_count;
        });
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  // Initialize AJAX cart handling
  function initAjaxCart() {
    // Handle all form submissions
    document.addEventListener('submit', function(e) {
      const form = e.target;

      // Check if this is a cart add form
      if (form && form.action && form.action.includes('/cart/add')) {
        e.preventDefault();
        e.stopPropagation();

        console.log('Add to cart form submitted');
        handleAjaxAddToCart(form);

        return false;
      }
    }, true);

    // Also handle button clicks directly
    document.addEventListener('click', function(e) {
      const addToCartBtn = e.target.closest('[data-add-to-cart]');

      if (addToCartBtn) {
        const form = addToCartBtn.closest('form');

        if (form && form.action && form.action.includes('/cart/add')) {
          e.preventDefault();
          e.stopPropagation();

          // Submit form via AJAX
          setTimeout(() => {
            if (!form.submitting) {
              form.submitting = true;
              handleAjaxAddToCart(form);

              setTimeout(() => {
                form.submitting = false;
              }, 1000);
            }
          }, 10);

          return false;
        }
      }
    }, true);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAjaxCart);
  } else {
    initAjaxCart();
  }

  // Re-initialize for dynamically loaded content
  document.addEventListener('shopify:section:load', initAjaxCart);

  // Handle product form submissions specifically
  document.addEventListener('product-form:submit', function(e) {
    if (e.detail && e.detail.form) {
      e.preventDefault();
      handleAjaxAddToCart(e.detail.form);
    }
  });
})();